import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { useLocation, useNavigate } from 'react-router-dom';
import Search from "../../../components/Search"
import { RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import FiltersContainer from "../../../components/Filters/components/FiltersContainer";
import { setCurrentPage, setSearchText } from "../../../redux/historicalSlice";
import { setHideFilter } from "../../../redux/filtersSlice";
import SpinerLoader from "../../../components/SpinerLoader";
import { useFiltersSurveyImport } from "../hooks/useFiltersSurveyImport";
import { useGetSurveyImports } from "../hooks/useGetSurveyImports";
import SurveyImportTable from "../components/SurveyImportTable";
import { useAlert } from "../../../hooks/useAlert";
import AlertMessage from "../../../components/AlertMessage";


export default function SurveyLoad() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch()
    const [message, setMessage] = useState<string | undefined>(location.state?.message);
    const { alert, hideAlert, isVisible, showAlert } = useAlert({ fromLocation: true });
    const [loading, setLoading] = useState(false);

    const { data: filters, isLoading: isFetchingSurveyLoads } = useFiltersSurveyImport();

    const currentPage = useSelector((state: RootState) => state.historical.surveyLoads.currentPage);
    const itemsPerPage = useSelector((state: RootState) => state.historical.surveyLoads.itemsPerPage);

    const [searchTerm, setSearchTerm] = useState("");

    const [isFilterVisible, setIsFilterVisible] = useState<boolean>(false)
    const isHideFilter = useSelector((state: RootState) => state.filters.surveyLoads.hideFilter);


    useEffect(() => {
        if (message) {
            showAlert({
                message: message,
                type: "success",
                duration: 8000
            })
        }
    }, [message]);

    const { data: surveyImportData, error, isError } = useGetSurveyImports();
    useEffect(() => {
        if (isError) {
            setLoading(false);
            showAlert({
                message: error?.message ?? t("common:requestError.errorBadRequest"),
                type: "danger",
                duration: 8000
            });
        }
    }, [isError, error]);

    useEffect(() => {
        if (location.state?.message) {
            // Limpiamos el estado para que no se muestre al recargar
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, []);



    const handleSearchInput = () => {
        dispatch(
            setSearchText({
                table: "surveyLoads",
                text: searchTerm || '',
                goFirstPage: true
            })
        )
    }

    const handleClear = () => {
        dispatch(setCurrentPage({ table: "surveyLoads", page: 1 }));
        dispatch(setSearchText({ table: "surveyLoads", text: '' }));
        setSearchTerm('');
    };

    const handleClick = () => {
        dispatch(setHideFilter({ table: 'surveyLoads', hide: false }));  
        setIsFilterVisible(!isFilterVisible);
    };

    return (
        
        <>
            {loading && (
                <div className="overlay-spinner">
                    <Spinner animation="border" variant="light" />
                </div>
            )}
           
            <Row className="mb-2 align-items-center justify-content-between">
                <Col xs={12} md="auto">
                    <h2>{t("survey:load.titleSuveyLoad")}</h2>
                </Col>
                <Col xs={12} md="auto" className="d-flex align-items-center justify-content-end mt-2 mt-md-0 mr-4" >
                    <Button
                        variant="primary"
                        style={{ whiteSpace: "nowrap", minWidth : "180px" }}
                        onClick={
                            () => navigate(`/survey-load/new-survey-load`)
                        }
                    >
                        {t("survey:load.buttonNewLoad")}
                    </Button>
                </Col>
                
            </Row>
            <Row>
                <Col className="text-center" xs={12} md={12}>
                    {isVisible && (
                        <AlertMessage
                            message={alert!.message}
                            type={alert!.type}
                            onClose={hideAlert}
                        />
                    )}
                </Col>
            </Row>
         
            <Row className="mb-2">
                <Col xs={11} className="mt-3">
                    <Search
                        searchText={searchTerm || ''}
                        onChange={setSearchTerm}
                        onSearch={handleSearchInput}
                        onClear={handleClear}
                    />
                </Col>
                <Col xs={1}>
                    <Button variant="" onClick={handleClick} aria-controls="collapse-filter-id" style={{ border: 0, }}>
                        <img
                            src="/filter.png"
                            alt="Filtar"
                            style={{ width: '50px', }}
                        />
                    </Button> 
                </Col>
            </Row>

            <div>
                {!isHideFilter && filters  && (
                    <div className="dashboard-section">
                        <FiltersContainer
                            filters={filters}
                            isFilterVisible={isFilterVisible && !isHideFilter}
                            tableKey="surveyLoads"
                            historicalKey="surveyLoads"
                        />
                    </div>
                )}
            </div>

            {isFetchingSurveyLoads ? (
                <div className="justify-content-center">
                    <SpinerLoader />
                </div>
            ) : (
                surveyImportData && (
                    <SurveyImportTable
                        surveyImportData={surveyImportData}
                        currentPage={currentPage}
                        pageSize={itemsPerPage}
                        totalPages={surveyImportData.totalPages}
                        setMessage={setMessage}
                    />
                )
            )}

        </>
        
    );
}


